import {firebaseJson} from './firebase-json';

export const environment = {
    production: true,
    hmr: false,
    firebase: firebaseJson()
};
